// extracted by mini-css-extract-plugin
export default {"priceTiding":"Overlay_priceTiding__x8Hg-"};